import React from 'react'

import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import PageRoutes from '@utils/page-routes'

const LegalSection: React.FC = () => {
  const { t } = useTranslation()
  return (
    <ul className="p-2.5 basis-1/2 sm:basis-[auto]">
      <li className="font-medium text-md mb-0.5">{t('footer.legal.title')}</li>
      <li className="py-0.5">
        <Link to={PageRoutes.legalTermsPath()} className="link" reloadDocument>
          {t('footer.legal.terms')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.legalPrivacyPath()} className="link" reloadDocument>
          {t('footer.legal.privacy')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.legalEducationPath()} className="link" reloadDocument>
          {t('footer.legal.education')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.legalCopyrightPath()} className="link" reloadDocument>
          {t('footer.legal.copyright')}
        </Link>
      </li>
      <li className="py-0.5">
        <Link to={PageRoutes.legalMusicPath()} className="link" reloadDocument>
          {t('footer.legal.musicTerms')}
        </Link>
      </li>
    </ul>
  )
}

export default LegalSection
